import { useBlock } from './useBlock'
import { useBranch } from './useBranch'
import { useLayer } from './useLayer'
import { useServer } from './useServer'
import { useWorkspaceName } from './useWorkspaceName'

export const useNavigationParams = () => {
  const layer = useLayer()
  const block = useBlock()
  const server = useServer()
  const branch = useBranch()
  const workspaceName = useWorkspaceName()

  return { layer, block, server, branch, workspaceName }
}
